module.exports = require("url");


//////////////////
// WEBPACK FOOTER
// external "url"
// module id = 145
// module chunks = 0